import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';

@Injectable()
export class SalesforceService {
    accessToken: string | undefined;

    refreshToken: string | undefined;

    instanceUrl: string;

    id: string;

    issuedAt: number;

    signature: string;

    state: string;

    scope: string;

    tokenType: string;

    constructor() {
        this.loadFromLocalStorage();
    }

    saveToLocalStorage() {
        localStorage.setItem(environment.salesforceKey, JSON.stringify({
            accessToken: this.accessToken,
            refreshToken: this.refreshToken,
            instanceUrl: this.instanceUrl,
            id: this.id,
            issuedAt: this.issuedAt,
            signature: this.signature,
            state: this.state,
            scope: this.scope,
            tokenType: this.tokenType
        }));
    }

    loadFromLocalStorage() {
        const data = localStorage.getItem(environment.salesforceKey);
        if (data) {
            const parsedData = JSON.parse(data);
            if ('accessToken' in parsedData) {
                this.accessToken = parsedData.accessToken;
                this.refreshToken = parsedData.refreshToken;
                this.instanceUrl = parsedData.instanceUrl;
                this.id = parsedData.id;
                this.issuedAt = parsedData.issuedAt;
                this.signature = parsedData.signature;
                this.state = parsedData.state;
                this.scope = parsedData.scope;
                this.tokenType = parsedData.tokenType;
            }
        }
    }

    clearFromLocalStorage() {
        localStorage.removeItem(environment.salesforceKey);
    }


}
